<span class="badge text-bg-warning rounded-pill text-white" *ngIf="productLine.dg_un">UN{{ productLine.dg_un }}</span>
<span class="badge text-bg-warning rounded-pill text-white"
      *ngIf="productLine.dg_class">{{ productLine.dg_class }}</span>
<span class="badge text-bg-warning rounded-pill text-white"
      *ngIf="productLine.dg_packaging_group">{{ productLine.dg_packaging_group }}</span>
<span class="badge  rounded-pill text-white" *ngIf="productLine.dg_un && productLine.dg_un !=='LQ'"
      [ngClass]="{'text-bg-danger': !productLine.dg_packaging, 'text-bg-warning': productLine.dg_packaging}"
>{{ productLine.dg_packaging ? productLine.dg_packaging : 'MANGLER EMBALLAGE' }}</span>

<span class="d-flex gap-2" >
<span *ngFor="let url of productLine.dg_icons">
    <img [src]="url" class="img-fluid mt-2" style="max-height: 30px">
</span>
</span>
